module.exports = __webpack_public_path__ + "static/media/XRP.efe535fb.svg";